import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-brand-gold/30 bg-brand-cream text-center text-brand-graphite/70 text-sm" data-id="element-69">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-70">
        <p className="text-xs leading-relaxed max-w-2xl mx-auto" data-id="element-71">
          © 2026 Functional Trainer System™ — Alle Rechte vorbehalten. Die auf
          dieser Website bereitgestellten Informationen dienen ausschließlich
          Bildungszwecken und sind als professionelle Ressource für
          zertifizierte Fitness- und Functional-Training-Fachleute konzipiert.
          Sie sind nicht dazu gedacht, das unabhängige professionelle Urteil
          oder lokale Sicherheitsstandards zu ersetzen. Nutzen Sie stets Ihre
          professionelle Expertise bei der Betreuung von Kunden.
        </p>
        <div className="flex justify-center gap-4 text-xs" data-id="element-72">
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-73">
            Allgemeine Geschäftsbedingungen
          </a>
          <span data-id="element-74">·</span>
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-75">
            Datenschutzrichtlinie
          </a>
          <span data-id="element-76">·</span>
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-77">
            Kontakt
          </a>
        </div>
      </div>
    </footer>;
}